import type { MaterialAndShadeCatalog } from "@jasper/use-cases";
import type {
  DescribableProduct,
  ProductDescriptionT,
  ProductTranslationsT,
} from "./describable.types";
import {
  describeProduct,
  getProductHeadline,
  getProductTypeLabel,
} from "./product";
import { formatTeeth } from "./teeth";

// Order lists: the headline of a single product, otherwise its different types (« Couronne + Bridge »)
export const getOrderTitle = (
  products: ReadonlyArray<Pick<DescribableProduct, "type" | "teeth">>,
  t: ProductDescriptionT,
  translateProduct: ProductTranslationsT
) => {
  if (products.length === 1) {
    return getProductHeadline(products[0], t, translateProduct);
  }

  const typeLabels = [
    ...new Set(
      products.map(product => getProductTypeLabel(product, translateProduct))
    ),
  ];

  return typeLabels.length
    ? typeLabels.join(" + ")
    : t("orderDescription.defaultTitle");
};

// TODO : page "mes commandes v2"
// Order lists: the description lines of a single product, otherwise each product with its teeth (« Bridge 14–16 »)
export const getOrderDetails = (
  products: ReadonlyArray<DescribableProduct>,
  materialAndShadeCatalog: MaterialAndShadeCatalog,
  t: ProductDescriptionT,
  translateProduct: ProductTranslationsT
): string[] =>
  products.length === 1
    ? describeProduct(products[0], materialAndShadeCatalog, t, translateProduct)
        .lines
    : products.map(product =>
        [
          getProductTypeLabel(product, translateProduct),
          formatTeeth(product.teeth, t),
        ]
          .filter(Boolean)
          .join(" ")
      );

// « 1 prothèse », « 3 prothèses » (French also takes the singular for 0)
export const getProductsCountLabel = (count: number, t: ProductDescriptionT) =>
  t("orderDescription.productsCount", { count });
